import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { ApiParameter } from "@insite/client-framework/Services/ApiService";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";
import { SubscribedEmailDto } from "@WhiteCap/Store/Reducer/WhiteCapReducer/OsnSubscriptionsDashboard/SubscriptionsDashboard";
import { ApplySoaSubscriptionsApiResultModel, applySoaSubscriptionsService } from "@WhiteCap/Store/Service/SoaSubscribersService";

export interface ApplySoaSubscriptionsApiParameter extends ApiParameter {
    customerId: string;
    subscribedEmails: SubscribedEmailDto [];
    isPrintPriceActive: boolean;
    onError?: (error: string) => void;
    onSuccess?: () => void;
}
type HandlerType = CustomApiHandler<ApplySoaSubscriptionsApiParameter, ApplySoaSubscriptionsApiResultModel>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
    props.dispatch({
        type: "Custom/SubscriptionDashboard/SoaSubscriptions/BeginApplySoaSubscriptions",
    });
};

export const MakeApiRequest: HandlerType = async props => {
    const result = await applySoaSubscriptionsService(
        props.apiParameter.customerId,
        props.apiParameter.subscribedEmails,
        props.apiParameter.isPrintPriceActive,
    );
    if (result.successful && result.result) {
        props.apiResult = result.result;
        if (props.apiParameter?.onSuccess) {
            props.apiParameter.onSuccess();
        }
    } else {
        if (props.apiParameter?.onError) {
            props.apiParameter.onError(result.errorMessage);
        }
        props.dispatch({
            type: "Custom/SubscriptionDashboard/SoaSubscriptions/ApplySoaSubscriptionsError",
        });
        return false;
    }
};

export const DispatchCompleteApplySoaSubscriptions: HandlerType = props => {
    props.dispatch({
        type: "Custom/SubscriptionDashboard/SoaSubscriptions/CompleteApplySoaSubscriptions",
        result: props.apiResult,
    });
};

export const chain = [PopulateApiParameter, MakeApiRequest, DispatchCompleteApplySoaSubscriptions];

const applySoaSubscriptions = createHandlerChainRunner(chain, "ApplySoaSubscriptions");
export default applySoaSubscriptions;
